import { AxiosError } from 'axios';
import { createAction, createAsyncAction } from 'typesafe-actions';
import {
  Contract,
  ContractParams,
  ContractSOV,
  EmptyContractSOVParams,
} from './types';

export const GET_CONTRACT_LIST = 'contracts/GET_CONTRACT_LIST';
export const GET_CONTRACT_LIST_SUCCESS = 'contracts/GET_CONTRACT_LIST_SUCCESS';
export const GET_CONTRACT_LIST_ERROR = 'contracts/GET_CONTRACT_LIST_ERROR';

export const GET_CONTRACT_LIST2 = 'contracts/GET_CONTRACT_LIST2';
export const GET_CONTRACT_LIST2_SUCCESS =
  'contracts/GET_CONTRACT_LIST2_SUCCESS';
export const GET_CONTRACT_LIST2_ERROR = 'contracts/GET_CONTRACT_LIST2_ERROR';

export const CREATE_CONTRACT = 'contracts/CREATE_CONTRACT';
export const CREATE_CONTRACT_SUCCESS = 'contracts/CREATE_CONTRACT_SUCCESS';
export const CREATE_CONTRACT_ERROR = 'contracts/CREATE_CONTRACT_ERROR';

export const UPDATE_CONTRACT = 'contracts/UPDATE_CONTRACT';
export const UPDATE_CONTRACT_SUCCESS = 'contracts/UPDATE_CONTRACT_SUCCESS';
export const UPDATE_CONTRACT_ERROR = 'contracts/UPDATE_CONTRACT_ERROR';

export const DELETE_CONTRACT = 'contracts/DELETE_CONTRACT';
export const DELETE_CONTRACT_SUCCESS = 'contracts/DELETE_CONTRACT_SUCCESS';
export const DELETE_CONTRACT_ERROR = 'contracts/DELETE_CONTRACT_ERROR';

export const UPDATE_CONTRACT_SOV_SYNC = 'contracts/UPDATE_CONTRACT_SOV_SYNC';

export const GET_CONTRACT_DETAIL = 'contracts/GET_CONTRACT_DETAIL';
export const GET_CONTRACT_DETAIL_SUCCESS =
  'contracts/GET_CONTRACT_DETAIL_SUCCESS';
export const GET_CONTRACT_DETAIL_ERROR = 'contracts/GET_CONTRACT_DETAIL_ERROR';

export const CREATE_CONTRACT_SOV = 'contracts/CREATE_CONTRACT_SOV';
export const CREATE_CONTRACT_SOV_SUCCESS =
  'contracts/CREATE_CONTRACT_SOV_SUCCESS';
export const CREATE_CONTRACT_SOV_ERROR = 'contracts/CREATE_CONTRACT_SOV_ERROR';

export const UPDATE_CONTRACT_SOV = 'contracts/UPDATE_CONTRACT_SOV';
export const UPDATE_CONTRACT_SOV_SUCCESS =
  'contracts/UPDATE_CONTRACT_SOV_SUCCESS';
export const UPDATE_CONTRACT_SOV_ERROR = 'contracts/UPDATE_CONTRACT_SOV_ERROR';

export const DELETE_CONTRACT_SOV = 'contracts/DELETE_CONTRACT_SOV';
export const DELETE_CONTRACT_SOV_SUCCESS =
  'contracts/DELETE_CONTRACT_SOV_SUCCESS';
export const DELETE_CONTRACT_SOV_ERROR = 'contracts/DELETE_CONTRACT_SOV_ERROR';

export const CREATE_EMPTY_CONTRACT_SOV = 'contracts/CREATE_EMPTY_CONTRACT_SOV';
export const CREATE_EMPTY_CONTRACT_SOV_SUCCESS =
  'contracts/CREATE_EMPTY_CONTRACT_SOV_SUCCESS';
export const CREATE_EMPTY_CONTRACT_SOV_ERROR =
  'contracts/CREATE_EMPTY_CONTRACT_SOV_ERROR';

export const BULK_CREATE_CONTRACT_SOV = 'contracts/BULK_CREATE_CONTRACT_SOV';
export const BULK_CREATE_CONTRACT_SOV_SUCCESS =
  'contracts/BULK_CREATE_CONTRACT_SOV_SUCCESS';
export const BULK_CREATE_CONTRACT_SOV_ERROR =
  'contracts/BULK_CREATE_CONTRACT_SOV_ERROR';

export const REMOVE_ALL_CONTRACT_SOV = 'contracts/REMOVE_ALL_CONTRACT_SOV';
export const REMOVE_ALL_CONTRACT_SOV_SUCCESS =
  'contracts/REMOVE_ALL_CONTRACT_SOV_SUCCESS';
export const REMOVE_ALL_CONTRACT_SOV_ERROR =
  'contracts/REMOVE_ALL_CONTRACT_SOV_ERROR';

export const UPDATE_CONTRACT_META_DATA = 'contracts/UPDATE_CONTRACT_META_DATA';
export const UPDATE_CONTRACT_META_DATA_SUCCESS =
  'contracts/UPDATE_CONTRACT_META_DATA_SUCCESS';
export const UPDATE_CONTRACT_META_DATA_ERROR =
  'contracts/UPDATE_CONTRACT_META_DATA_ERROR';

export const getContractListAsync = createAsyncAction(
  GET_CONTRACT_LIST,
  GET_CONTRACT_LIST_SUCCESS,
  GET_CONTRACT_LIST_ERROR,
)<ContractParams, Contract[], AxiosError>();

export const getContractList2Async = createAsyncAction(
  GET_CONTRACT_LIST2,
  GET_CONTRACT_LIST2_SUCCESS,
  GET_CONTRACT_LIST2_ERROR,
)<ContractParams, Contract, AxiosError>();

export const createContractAsync = createAsyncAction(
  CREATE_CONTRACT,
  CREATE_CONTRACT_SUCCESS,
  CREATE_CONTRACT_ERROR,
)<ContractParams, Contract, AxiosError>();

export const updateContractAsync = createAsyncAction(
  UPDATE_CONTRACT,
  UPDATE_CONTRACT_SUCCESS,
  UPDATE_CONTRACT_ERROR,
)<ContractParams, Contract, AxiosError>();

export const deleteContractAsync = createAsyncAction(
  DELETE_CONTRACT,
  DELETE_CONTRACT_SUCCESS,
  DELETE_CONTRACT_ERROR,
)<ContractParams, number, AxiosError>();

export const updateContractSOVSync = createAction(
  UPDATE_CONTRACT_SOV_SYNC,
)<Contract>();

export const getContractDetailAsync = createAsyncAction(
  GET_CONTRACT_DETAIL,
  GET_CONTRACT_DETAIL_SUCCESS,
  GET_CONTRACT_DETAIL_ERROR,
)<ContractParams, Contract, AxiosError>();

export const createContractSOVAsync = createAsyncAction(
  CREATE_CONTRACT_SOV,
  CREATE_CONTRACT_SOV_SUCCESS,
  CREATE_CONTRACT_SOV_ERROR,
)<ContractParams, ContractSOV, AxiosError>();

export const updateContractSOVAsync = createAsyncAction(
  UPDATE_CONTRACT_SOV,
  UPDATE_CONTRACT_SOV_SUCCESS,
  UPDATE_CONTRACT_SOV_ERROR,
)<ContractParams, ContractSOV, AxiosError>();

export const deleteContractSOVAsync = createAsyncAction(
  DELETE_CONTRACT_SOV,
  DELETE_CONTRACT_SOV_SUCCESS,
  DELETE_CONTRACT_SOV_ERROR,
)<ContractParams, number, AxiosError>();

export const createEmptyContractSOVAsync = createAsyncAction(
  CREATE_EMPTY_CONTRACT_SOV,
  CREATE_EMPTY_CONTRACT_SOV_SUCCESS,
  CREATE_EMPTY_CONTRACT_SOV_ERROR,
)<EmptyContractSOVParams, ContractSOV, AxiosError>();

export const bulkCreateContractSOVAsync = createAsyncAction(
  BULK_CREATE_CONTRACT_SOV,
  BULK_CREATE_CONTRACT_SOV_SUCCESS,
  BULK_CREATE_CONTRACT_SOV_ERROR,
)<ContractParams, Contract, AxiosError>();

export const removeAllContractSOVAsync = createAsyncAction(
  REMOVE_ALL_CONTRACT_SOV,
  REMOVE_ALL_CONTRACT_SOV_SUCCESS,
  REMOVE_ALL_CONTRACT_SOV_ERROR,
)<ContractParams, Contract, AxiosError>();

export const updateContractMetaDataAsync = createAsyncAction(
  UPDATE_CONTRACT_META_DATA,
  UPDATE_CONTRACT_META_DATA_SUCCESS,
  UPDATE_CONTRACT_META_DATA_ERROR,
)<ContractParams, Contract, AxiosError>();
